<template>
  <div class="col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start gap-2">
    <span class="text-muted" style="font-size:13px; white-space:nowrap;">แสดง</span>
    <select
      v-if="itemsPerPageDropdownEnabled"
      class="perpage-select"
      v-model="itemsCountInTable"
      name="items-per-page"
      id="items-per-page"
    >
      <option :value="10">10</option>
      <option :value="25">25</option>
      <option :value="50">50</option>
      <option :value="100">100</option>
    </select>
    <span class="text-muted" style="font-size:13px; white-space:nowrap;">รายการ</span>
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  onMounted,
  WritableComputedRef,
  computed,
} from "vue";

export default defineComponent({
  name: "table-items-per-page-select",
  components: {},
  props: {
    itemsPerPage: { type: Number, default: 10 },
    itemsPerPageDropdownEnabled: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  emits: ["update:itemsPerPage"],
  setup(props, { emit }) {
    const inputItemsPerPage = ref(10);

    onMounted(() => {
      inputItemsPerPage.value = props.itemsPerPage;
    });

    const itemsCountInTable: WritableComputedRef<number> = computed({
      get(): number {
        return props.itemsPerPage;
      },
      set(value: number): void {
        emit("update:itemsPerPage", value);
      },
    });

    return {
      itemsCountInTable,
    };
  },
});
</script>

<style scoped>
.perpage-select {
  padding: 6px 10px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 13px;
  color: #374151;
  background: white;
  cursor: pointer;
  outline: none;
  transition: border-color 0.15s;
}
.perpage-select:focus { border-color: #323563; box-shadow: 0 0 0 3px rgba(50,53,99,0.1); }
</style>
